import React from 'react';
import './WhyUs.css';

const REASONS = [
  { num: '01', title: 'One team, whole funnel', desc: 'The people building your product sit next to the people filling your pipeline.' },
  { num: '02', title: 'You own everything', desc: 'Your repo, your CRM, your ad accounts, and your IP, all from day one.' },
  { num: '03', title: 'Measured in results', desc: 'Weekly demos and pipeline reporting, not activity reports.' },
];

export default function WhyUs() {
  return (
    <section className="why" id="why">
      <div className="why-inner">
        <div className="why-heading">
          <div className="why-eyebrow" data-reveal>WHY ROONBASH</div>
          <h2 data-reveal>Strategy, build, and growth without the hand-offs.</h2>
        </div>
        <div className="why-reasons">
          {REASONS.map((r) => (
            <div className="why-row" data-reveal key={r.num}>
              <div className="why-num">{r.num}</div>
              <div className="why-title">{r.title}</div>
              <div className="why-desc">{r.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
